// eslint-disable-next-line no-unused-vars
import React from 'react'

const AuthLayout = ({ children }) => children

export default AuthLayout
